import * as yup from 'yup'

const schema = (isUnique) => {
  return yup.object({
    ...(isUnique && {
      departments: yup
        .array()
        .min(1, 'Selecione um departamento para poder gerar o relatório')
        .required(),
    }),

    exportFormat: yup.string().required('Selecione um formato de exportação.'),
  })
}

export default schema
